import { useSelector } from "react-redux";
import { wrapper } from "../../../redux";
import { addBreadcrumb } from "../../../redux/action-creaters/breadcrumbs";
import LeftSide from "../../../components/layouts/leftSide";
import InfoMenu from "../../../components/pages/partners/menu";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../../utils/errors/sspWrapper";

export default function OptPage({ scripts, host }) {
  const { content } = useSelector((state) => state.meta);
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide side={<InfoMenu></InfoMenu>} title="Оптовые продажи">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(
      addBreadcrumb({ link: "/partners/", name: "Оптовые продажи" }),
    );

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/partners/opt/",
    );
  }),
);
